import { useCallback, useRef } from "react";
import Slider from "@mui/material/Slider";
import { actionMapviewInSlider } from "../App/MiscRedux";
import { useDispatch } from "react-redux";

export const ViewAwareSlider = ({
  onChange,
  onChangeCommitted,
  label,
  ...props
}) => {
  const dispatch = useDispatch();
  const isDraggingRef = useRef(false);

  const handleChange = useCallback(
    (event, value, activeThumb) => {
      if (!isDraggingRef.current) {
        isDraggingRef.current = true;
        // Tell view history to ignore these events.
        dispatch(actionMapviewInSlider(true));
      }
      if (onChange) {
        onChange(event, value, activeThumb);
      }
    },
    [onChange],
  );

  const handleChangeCommitted = useCallback(
    (event, value) => {
      isDraggingRef.current = false;
      // Enable view history and re-emit the last value so it can
      // be recorded in history.
      dispatch(actionMapviewInSlider(false));
      if (onChange) {
        onChange(event, value);
      }
      if (onChangeCommitted) {
        onChangeCommitted(event, value);
      }
    },
    [onChange, onChangeCommitted],
  );

  return (
    <Slider
      {...props}
      onChange={handleChange}
      onChangeCommitted={handleChangeCommitted}
      slotProps={{ input: { "aria-label": label } }}
    />
  );
};

export default ViewAwareSlider;
